<template>

	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link :to="{ name: 'calcdictGroupData', params: {dictCode: dictCode, page: page} }"
									 id="buttonback">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к списку справочников
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">

						<div class="name">
							<h3 class="title">Редактирование элемента справочника </h3>
							<div class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep" v-if="selectedDataId">

								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field>
										<label>{{mapElementName['id']}}</label>
										<md-input type="text" readonly v-model="form['id']"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('valueId')">
										<label>{{mapElementName['valueId']}}</label>
										<md-input type="text" v-model="form['valueId']"></md-input>
										<span class="md-error"
											  v-if="!$v.form.valueId.required">Обязательно для заполнения</span>
									</md-field>
								</div>
								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('value')">
										<label>{{mapElementName['value']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model="form['value']"></md-input>
										<md-input type="text" v-else v-model="form['value']"></md-input>
										<span class="md-error"
											  v-if="!$v.form.value.required">Обязательно для заполнения</span>
									</md-field>
								</div>

								<div class="md-layout-item text-center md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field>
										<label>{{mapElementName['valOrder']}}</label>
										<md-input type="number"
												  v-model.number="form['valOrder']"></md-input>
									</md-field>
								</div>
							</div>
							<br/>
							<div class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep">

								<template v-if="selectedDataId">
									<md-button @click="validateData(saveItem)"
											   class="md-button md-success md-theme-default"
											   v-if="action !== 'delete'">
										Сохранить
									</md-button>

									<md-button @click="validateData(deleteItem)"
											   class="md-button md-primary  md-theme-default"
											   v-if="action === 'delete'">
										Удалить
									</md-button>

								</template>
							</div>
						</div>

					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
    import {
        required,
    } from 'vuelidate/lib/validators'
    import { saveItem, deleteItem, calcdictGroupData } from '@/utils/dict-api'

    export default {
        mixins: [
            validationMixin,
        ],
        components: {},
        bodyClass: 'dictionary-data',
        props: ['page', 'action'],
        data () {
            return {
                options: [],
                dictCode: this.$route.params.code,
                code: this.$route.params.code,
                calcDictData: [],
                dictionaryId: '',
                selectedDataId: this.$route.params.id,
                selectedData: null,
                form: {
                    action: 'save',
                    dictCode: this.$route.params.code,
                    id: '',
                    valOrder: '',
                    value: '',
                    valueId: '',
                },
                mapElementName: {
                    'valOrder': 'Порядок отображения',
                    'value': 'Название',
                    'valueId': 'Значение',
                    'id': 'ID',
                },
            }
        },
        validations: {
            form: {
                value: {
                    required,
                },
                valueId: {
                    required,
                },
                valOrder: {
                    required
                },
            },
        },
        watch: {},
        methods: {
            getValidationClass (fieldName) {
                const field = this.$v.form[fieldName]
                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty,
                    }
                }
            },
            validateData (sendFn) {
                this.$v.form.$touch()
                if (!this.$v.form.$invalid) {
                    sendFn()
                }
            },
            setData: function (data) {
                this.form = data
            },
            getElementData: function () {
                if (this.selectedDataId === 'new') {
                    this.addItem()
                    return
                }
                checkAuthentication(this.$router, this.$route).then(response => {
                    // получаем все, фильтруем по id
                    calcdictGroupData(this.code).then(result => {
                        if (result) {
                            this.calcDictData = result
                            var that = this
                            this.calcDictData.forEach(function (item) {
                                if (item.id == that.selectedDataId) {
                                    that.setData(item)
                                }
                            })
                        }
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            addItem: function () {
                const item = {
                    'id': 'new',
                    'value': '',
                    'valOrder': '',
                    'valueId': '',
                }

                this.setData(item)

            },
            deleteItem: function () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    deleteItem('dict', JSON.stringify({ id: this.$route.params.id })).then(result => {
                        this.$router.push({ name: 'calcdictGroupData', params: { code: this.dictCode } })
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            saveItem: function () {
                if (this.form.id === 'new') {
                    this.form.id = null
                }
                this.form.dictCode = this.dictCode
                saveItem('dict', JSON.stringify(this.form)).then(result => {
                    this.$router.push({ name: 'calcdictGroupData', params: { dictCode: this.dictCode } })
                }).catch(error => {
                    reAuthenticate(this.$router, this.$route, error)
                })
            },
            checkEditableNames: function (name) {
                const editableNames = ['valueId', 'value', 'order']
                return (editableNames.indexOf(name) >= 0)
            },
        },
        created () {
            if (this.$route.params.action == 'delete') {
                this.deleteItem()
            } else {
                this.getElementData()
            }
        },
    }
</script>


<style lang="scss" scoped type="text/scss">
	.dictionary-data .md-field {
		padding-top: 16px;
		margin: 4px 0 24px;
	}

	.offset-left-16 {
		margin-left: 16px;
	}
</style>




